import { observer } from 'mobx-react-lite';

import { CommandButton, IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import setAllowShowMultipleRows from 'owa-attachment-well-data/lib/actions/setAllowShowMultipleRows';
import setCanOverrideAllowShowMultipleRows from 'owa-attachment-well-data/lib/actions/setCanOverrideAllowShowMultipleRows';
import AttachmentWellViewState from 'owa-attachment-well-data/lib/schema/AttachmentWellViewState';
import { ClientAttachmentId } from 'owa-client-ids';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import getAttachmentWellInfoString from '../utils/getAttachmentWellInfoString';
import getAllowShowMultipleRows from './Helpers/getAllowShowMultipleRows';

export interface AttachmentWellInfoProps {
    attachmentWellViewState: AttachmentWellViewState;
    attachmentIdBeingPreviewed: ClientAttachmentId;
}

const styles = require('./AttachmentWellInfoView.scss');
const barStyles = require('./AttachmentWellBarView.scss');
const classNames = require('classnames');

// This component is responsible for showing the attachment well info view.
export default observer(function AttachmentWellInfoView(props: AttachmentWellInfoProps) {
    const onClickShowAllButton = (ev: any) => {
        setAllowShowMultipleRows(props.attachmentWellViewState, true);
    };
    const onClickShowOneRowButton = (ev: any) => {
        setAllowShowMultipleRows(props.attachmentWellViewState, false);
        setCanOverrideAllowShowMultipleRows(props.attachmentWellViewState, false);
    };
    const didViewOverflowOneRow = props.attachmentWellViewState.didViewOverflowOneRow;
    const isShowingMultipleRows = getAllowShowMultipleRows(
        props.attachmentWellViewState,
        props.attachmentIdBeingPreviewed
    );
    const infoString = getAttachmentWellInfoString(
        props.attachmentWellViewState,
        didViewOverflowOneRow,
        isShowingMultipleRows
    );
    const buttonProps: IButtonProps = {
        iconProps: {},
    };
    let buttonStyle;
    let ariaProps: AriaProperties;
    if (didViewOverflowOneRow) {
        if (isShowingMultipleRows) {
            buttonProps.onClick = onClickShowOneRowButton;
            buttonProps.iconProps.iconName = ControlIcons.DoubleChevronUp;
            ariaProps = {
                role: AriaRoles.button,
                expanded: true,
            };
        } else {
            buttonProps.onClick = onClickShowAllButton;
            buttonProps.iconProps.iconName = ControlIcons.DoubleChevronDown;
            ariaProps = {
                role: AriaRoles.button,
                expanded: false,
            };
        }
        buttonProps.disabled = false;
        buttonStyle = classNames(barStyles.barButton, barStyles.barButtonHover);
    } else {
        buttonProps.disabled = true;
        buttonStyle = barStyles.barButton;
    }
    return (
        <span>
            <CommandButton
                {...generateDomPropertiesForAria(ariaProps)}
                className={buttonStyle}
                disabled={buttonProps.disabled}
                iconProps={{
                    iconName: buttonProps.iconProps.iconName,
                    styles: {
                        root: styles.chevronButton,
                    },
                }}
                onClick={buttonProps.onClick}>
                {infoString}
            </CommandButton>
        </span>
    );
});
